import { ComponentProps, createContext } from 'react';
import NavigationHeader from './NavigationHeader';

const NavBarSearchStateSetterContext = createContext<{
  setNavBarOnResultSelect: (onResultSelect: ComponentProps<typeof NavigationHeader>['onResultSelect']) => void;
  setNavBarValue: (value: string) => void;
}>(undefined);

export default NavBarSearchStateSetterContext;
